import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import PcpReferralAddClientView from '../components/views/pcpReferralAddClientView'
import { Page, PageHeader } from '../ui'

function PcpReferralAddClient() {
    return (
        <div className="home">
            <Sidebar />
            <MainView>
                <Page>
                    <PageHeader
                        eyebrow="PCP Referral"
                        title="Add Client"
                        intro="Create a new client record in the PCP Referral schema. Address lookups use Data8 — email and telephone are also validated against Data8 in real time. Once saved, you can send the CFA e-sign link by email or SMS."
                    />
                    <PcpReferralAddClientView />
                </Page>
            </MainView>
        </div>
    )
}

export default PcpReferralAddClient
